<div
  class="flex items-center justify-between rounded-[8px] rounded-md border border-[#96D0D0] bg-[#E6EFEF]"
  matSnackBarLabel
>
  <div class="flex items-center gap-[8px]">
    <mat-icon class="h-[20px] w-[20px] text-[#05565A]" svgIcon="check-circle" />
    <h1 class="text-[0.8rem] text-[#05565A]">{{ snackBarVar.message }}</h1>
  </div>
</div>
